export default class Quantity {
    constructor() {
        this.quantityBlock = $('.product-hero__quantity')
        this.quantityPlus = $('.product-hero__quantity input[name=increase]')
        this.quantityMinus = $('.product-hero__quantity input[name=decrease]')
        this.quantityInput = $('.product-hero__quantity input[name=quantity]')
    }

    increaseQuantity() {
        let initVal = parseInt(this.quantityInput.val())

        if (initVal < this.quantityInput.attr("max") ) {
            this.quantityInput.val(initVal + 1)
        }
    }

    decreaseQuantity() {
        let initVal = parseInt(this.quantityInput.val())

        if (initVal > 1) {
            this.quantityInput.val(initVal - 1)
        }
    }

    init() {
        if (this.quantityBlock) {
            $(document).on('click', '.product-hero__quantity input[name=increase]', () => this.increaseQuantity())
            $(document).on('click', '.product-hero__quantity input[name=decrease]', () => this.decreaseQuantity())
        }
    }
}
